module.exports = new __parcel__URL__("google-logo.5867462c.svg").toString();